import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
var StyledCircle = styled("div")(function (_a) {
    var colors = _a.colors;
    return ({
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: colors ? colors.backgroundColor : "var(--red-color-10)",
        border: colors ? "1px solid ".concat(colors.borderColor) : "1px solid #F48686",
    });
});
var CircleComponent = function (_a) {
    var colors = _a.colors;
    return _jsx(StyledCircle, { colors: colors });
};
export default CircleComponent;
